import type { App } from 'vue';
import type { ArcoIconOptions } from '../../_utils/types';
import _IconFileDocColor from './icon-file-doc-color.vue';

const IconFileDocColor = Object.assign(_IconFileDocColor, {
  install: (app: App, options?: ArcoIconOptions) => {
    const iconPrefix = options?.iconPrefix ?? '';
    app.component(iconPrefix + _IconFileDocColor.name, _IconFileDocColor);
  }
});

export default IconFileDocColor;
